export type FunnelIntent = 'buy_ticket' | 'create_event'

export type AnalyticsEventName =
  | 'buy_ticket_event_listing'
  | 'buy_ticket_login'
  | 'buy_ticket_event_detail'
  | 'buy_ticket_registration_complete'
  | 'create_event_login'
  | 'create_event_dashboard'
  | 'create_event_step_1'
  | 'create_event_step_2'
  | 'create_event_step_3'
  | 'create_event_published'

const BUY_TICKET_DETAIL_SESSION_KEY = 'Forumm_buy_ticket_event_detail'

export const parseFunnelIntent = (
  value: string | string[] | undefined
): FunnelIntent | undefined => {
  const intent = Array.isArray(value) ? value[0] : value
  return intent === 'buy_ticket' || intent === 'create_event'
    ? intent
    : undefined
}

export const getFunnelIntentForPath = (
  pathname: string
): FunnelIntent | undefined =>
  /^\/event(?:\/|$)/.test(pathname) ? 'buy_ticket' : undefined

export const getFunnelLoginEvent = (
  intent: FunnelIntent | undefined
): AnalyticsEventName | undefined => {
  if (intent === 'buy_ticket') return 'buy_ticket_login'
  return 'create_event_login'
}

export const pushDataLayerEvent = (eventName: AnalyticsEventName): void => {
  console.log({ triggeredEvent: eventName })
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
  })
  console.log({ dataLayer: window.dataLayer })
}

export const shouldTrackBuyTicketEventDetail = (eventId: string): boolean => {
  if (typeof window === 'undefined') return false

  try {
    if (window.sessionStorage.getItem(BUY_TICKET_DETAIL_SESSION_KEY) === eventId)
      return false

    window.sessionStorage.setItem(BUY_TICKET_DETAIL_SESSION_KEY, eventId)
  } catch {
    // Analytics should still work when storage is unavailable.
  }

  return true
}

export const clearBuyTicketEventDetail = (eventId: string): void => {
  if (typeof window === 'undefined') return

  try {
    if (window.sessionStorage.getItem(BUY_TICKET_DETAIL_SESSION_KEY) === eventId)
      window.sessionStorage.removeItem(BUY_TICKET_DETAIL_SESSION_KEY)
  } catch {
    // Storage is optional; there is nothing to clear when it is unavailable.
  }
}

export const pushFunnelLoginEvent = (
  intent: FunnelIntent | undefined
): void => {
  const eventName = getFunnelLoginEvent(intent)
  if (eventName) pushDataLayerEvent(eventName)
}

export default pushDataLayerEvent
